module.exports = __webpack_public_path__ + "static/media/GPS_back.aea69258.jpg";